<template>
    <div class="popup rd-dialog rd-wheel rd-lottery-grid" :class="classObj">
        <van-popup :value="show" @click-overlay="close" @open="open">
            <div class="content">
                <div class="header">
                    <div>{{ $t('turntable.title') }}</div>
                    <div class="close">
                        <i class="iconfont icon-s-cuowu-guanbi" @click="close"></i>
                    </div>
                </div>
                <div class="box">
                    <div class="total_box">
                        <div class="total">
                            <div class="total1">
                                <div>
                                    <span>{{ $t('turntable.totalTips1') }}</span>
                                    <span class="num">{{ memberLuckyAmt }}</span>
                                </div>
                                <!-- <view>{{$t('turntable.detail')}}</view> -->
                            </div>
                            <div v-if="luckyWheelReward == 'everydayFirstrecharge'" class="total2">
                                <span>{{ $t('turntable.totalTips5') }}</span>
                                <span class="num">{{ bettingGainLucky }}</span>
                                <span>{{ $t('turntable.totalTips6') }}</span>
                            </div>
                            <div v-else-if="luckyWheelReward == 'oneRecharge'" class="total2">
                                <span>{{ $t('turntable.totalTips7') }}</span>
                                <span class="num">{{ bettingGainLucky }}</span>
                                <span>{{ $t('turntable.totalTips8') }}</span>
                            </div>
                            <div v-else class="total2">
                                <span>{{ $t('turntable.totalTips2') }}</span>
                                <span class="num">1</span>
                                <span>{{ $t('turntable.totalTips3') }}</span>
                                <span class="num">{{ bettingGainLucky }}</span>
                                <span>{{ $t('turntable.totalTips4') }}</span>
                            </div>
                        </div>
                        <div class="total_decoration"></div>
                    </div>
                    <div class="turntable_content">
                        <div class="type">
                            <div v-for="(item, index) in turntableList" :key="index" class="item"
                                :class="{ 'act': typeAct == index }" @click="changeTurntable(index)">
                                <div v-if="item.turntableSwitch == 'silver'">{{ $t('turntable.Silver') }}</div>
                                <div v-if="item.turntableSwitch == 'gold'">{{ $t('turntable.Gold') }}</div>
                                <div v-if="item.turntableSwitch == 'diamond'">{{ $t('turntable.Diamond') }}</div>
                                <div>
                                    <span>{{ item.luckyNum }}</span>
                                    <span>{{ $t('turntable.totalTips4') }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="turntable_content_box" v-if="turntableList.length">
                            <div v-for="(item, index) in turntableList" :key="index">
                                <div v-if="typeAct == index && item.luckyWheelModelDetailOddsVoList.length"
                                    class="turntable">
                                    <div class="turntable_main" >
                                        <div class="item"
                                            :class="{ 'active': activeIndex === cindex }"
                                            v-for="(citem, cindex) in item.luckyWheelModelDetailOddsVoList"
                                            :key="cindex">
                                            <div class="chose_item" v-if="activeIndex === cindex">
                                                <img src="@/assets/turntable/item_act_bg.png" />
                                            </div>
                                            <div v-if="citem.amount && citem.amount > 0" class="item-content">
                                                <img class="item-img"
                                                    :src="citem.img || require('@/assets/turntable/icon-money.png')" />
                                                <div class="item-name">
                                                    {{ citem.amount }}
                                                </div>
                                            </div>
                                            <div v-else class="item-empty">
                                                <img class="item-img" src="@/assets/turntable/empty-money.png" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="turntable_btn">
                                        <div>
                                            <div class="nums">
                                                {{drawNumbers}}
                                            </div>
                                            <div class="draw_txt">
                                                {{$t('turntable.drawNumbers')}}
                                            </div>
                                        </div>
                                        <img v-if="drawNumbers>0" class="turntable_btn_img"
                                            src="@/assets/turntable/turntable-btn4.png"
                                            @click="onTurn(item.turntableSwitch)" />
                                        <img v-else class="turntable_btn_img" src="@/assets/turntable/turntable-btn4_disable.png"
                                            @click="onTurn(item.turntableSwitch)" />
                                    </div>
                                </div>
                                <div class="action_btn" @click="onTurn(turntableList[typeAct].turntableSwitch)">
                                    <img v-if="drawNumbers>0" src="@/assets/turntable/action_btn.png" />
                                    <img v-else src="@/assets/turntable/action_btn_disable.png" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tabs">
                        <div class="tabs-header">
                            <div class="tabs-header-item" :class="{ act: tabAct === 0 }" @click="onChangeTab(0)">
                                {{ $t('turntable.tab1') }}
                            </div>
                            <div class="tabs-header-item" :class="{ act: tabAct === 1 }" @click="onChangeTab(1)">
                                {{ $t('turntable.tab2') }}
                            </div>
                        </div>
                        <div class="tabs-content">
                            <div class="tabs-content-inset">
                                <div class="tabs-content-item" v-if="tabAct == 0">
                                    <div :style="dataScrollStyle">
                                        <div class="tr" v-for="(item, index) in winningList" :key="index">
                                            <div class="td"> {{ item.phone }} </div>
                                            <div class="td">{{ $t('turntable.JustRemoved') }}</div>
                                            <div class="td money">{{ CurrencyType }}+{{ item.money }}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="tabs-content-item records" v-if="tabAct == 1">
                                    <div v-if="recordList.length">
                                        <div class="tr" v-for="(item, index) in recordList" :key="index">
                                            <div class="td">{{ item.createTime }}</div>
                                            <div class="td">{{ $t('turntable.JustRemoved') }}</div>
                                            <div class="td money">{{ CurrencyType }}+{{ item.amount }}</div>
                                        </div>
                                        <div v-if="recordLoading" class="last-tips">
                                            <a-spin>
                                                <a-icon slot="indicator" type="loading" spin />
                                            </a-spin>
                                            {{ $t("lang.Loading") }}
                                        </div>
                                        <div class="last-tips" v-else-if="recordHasMore"
                                            @click="getTurntableDrawRecords">
                                            {{ $t("lang.LoadMore") }}
                                        </div>
                                        <div v-else class="last-tips">{{ $t("lang.AllLoaded") }}</div>
                                    </div>
                                    <div class="empty" v-else>
                                        <img src="@/assets/common/empty.png" alt="" class="empty_img">
                                        <div>{{ $t("lang.NoData") }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="rule_box">
                        <div class="title">
                            {{ $t("signin.Rules") }}
                        </div>
                        <div class="rule" v-html="rulesDesc"></div>
                    </div>
                </div>
            </div>
        </van-popup>
        <WinPopup ref="WinPopup"></WinPopup>
    </div>
</template>

<script>
import { mapState } from 'vuex'
// import { Dialog } from 'vant'
import {
    getEventsHomeShow
} from '@/api/home'
import { getTurntableInfo, getTurntableDrawRecords, onTurntableDraw } from '@/api/turntable'
import { getUserInfo } from '@/api/user'
import WinPopup from './modules/WinPopup'
export default {
    name: 'turntablePop',
    components: { WinPopup },
    data() {
        return {
            firstLoaded: true,
            memberLuckyAmt: 0, // 用户当前拥有多少幸运值
            bettingGainLucky: 1, // 投注1获得多少幸运点
            luckyWheelReward: '', // gameBetting有效投注(默认)  everydayFirstrecharge每日首充
            turntableList: [],
            typeAct: 0,
            drawNumbers: 0, // 抽奖次数
            activeIndex: null,
            intervalId: null,
            speed: 50,
            prizeList: [], // 奖品列表，
            isTurnIng: false, // 是否转动
            startRotateDegree: 0, // 开始转动的角度
            rotateAngle: 0, // 设置指针默认指向的位置,现在是默认指向2个扇形之间的边线上
            rotateTransition: '',
            amt: 0, // 中奖金额
            tabAct: 0,
            // 中奖名单
            winningList: [],
            getWinningListInterval: null,
            dataScrollStyle: '',
            dataScrollInterval: null,
            recordPageNo: 0,
            recordHasMore: true,
            recordLoading: false,
            recordList: [],
            rulesDesc: '' // 活动说明
        }
    },
    computed: {
        isLogin() {
            return !!this.$store.getters.token
        },
        ...mapState({
            device: state => state.app.device
        }),
        classObj() {
            return {
                mobile: this.device === 'mobile'
            }
        },
        eventId: {
            get() {
                return this.$store.state.user.turntableEventId
            },
            set() { }
        },
        show: {
            get() {
                return this.$store.getters.isShowTurntable2Popup
            },
            set(val) {
                return val
            }
        },
        getRotateAngle() {
            return index => {
                const list = this.turntableList.length ? this.turntableList[this.typeAct].luckyWheelModelDetailOddsVoList : []
                return {
                    transform: `rotate(${(360 / list.length) * index}deg) skewY(${360 / list.length - 90}deg)`
                }
            }
        },
        getCorrectAngle() {
            return index => {
                const list = this.turntableList.length ? this.turntableList[this.typeAct].luckyWheelModelDetailOddsVoList : []
                return {
                    transform: `skewY(${90 - 360 / list.length}deg) skewX(0deg) rotate(${180 / list.length}deg)`
                }
            }
        },
        getMainStyle() {
            return `
				transform: ${this.rotateAngle};
				transition: ${this.rotateTransition};
			`
        }
    },
    created() {
    },
    destroyed() {
        clearInterval(this.dataScrollInterval)
        clearInterval(this.getWinningListInterval)
    },
    methods: {
        open() {
            if (this.firstLoaded) {
                this.init()
            }
        },
        close() {
            this.$store.dispatch('user/setIsShowTurntable2Popup', { id: '', show: false })
        },
        init() {
            this.getInfo()
        },
        changeTurntable(index) {
            if (this.isTurnIng) return
            this.typeAct = index
            this.drawNumbers = Math.floor(this.memberLuckyAmt / this.turntableList[index].luckyNum)
        },
        getInfo() {
            const that = this
            if (this.eventId) {
                that.getTurntableInfo(this.eventId).then((list) => {
                    that.getWinningList(list)
                    that.getWinningListInterval = setInterval(() => {
                        that.getWinningList(list)
                    }, 60 * 1000 * 10)
                }).then(() => {
                    this.changeTurntable(this.typeAct)
                })
                this.onDataScroll()
            } else {
                getEventsHomeShow().then((res) => {
                    if (res.code) return
                    const D = res.result.eventManageList
                    const item = D.filter(item => item.eventType === 'luckyWheel')
                    const that = this
                    that.eventId = item[0].id
                    that.getTurntableInfo(that.eventId).then((list) => {
                        that.getWinningList(list)
                        that.getWinningListInterval = setInterval(() => {
                            that.getWinningList(list)
                        }, 60 * 1000 * 10)
                    }).then(() => {
                        this.changeTurntable(this.typeAct)
                    })
                    this.onDataScroll()
                })
            }
        },
        getTurntableInfo(id, isNoLoading = false) {
            return new Promise((resolve, reject) => {
                getTurntableInfo({ id }, isNoLoading).then((res) => {
                    this.LoadingNum++
                    if (res.code) return
                    const D = res.result
                    this.memberLuckyAmt = D.value1.luckyAmt
                    this.bettingGainLucky = D.value0.bettingGainLucky
                    this.rulesDesc = D.value0.eventContent
                    this.turntableList = D.value0.luckyWheelModelDetailVoList || []
                    this.luckyWheelReward = D.value0.luckyWheelReward
                    this.firstLoaded = false
                    resolve(this.turntableList[this.turntableList.length - 1]?.luckyWheelModelDetailOddsVoList)
                }).catch(err => {
                    reject(err)
                })
            })
        },
        onChangeTab(act) {
            if (this.tabAct === act) return
            this.tabAct = act
            if (act === 0) {
                this.onDataScroll()
            }
            if (act === 1) {
                this.getTurntableDrawRecords()
            }
        },
        // 获取抽奖记录
        getTurntableDrawRecords(isNoLoading = false) {
            this.recordPageNo++
            if (this.recordLoading) return
            this.recordLoading = true
            getTurntableDrawRecords({
                id: this.eventId,
                pageNo: this.recordPageNo,
                pageSize: 20
            }, isNoLoading).then((res) => {
                if (res.code) return
                const D = res.result
                this.recordList = this.recordList.concat(D.records)
                this.recordHasMore = D.total > this.recordList.length
            }).finally(() => {
                this.recordLoading = false
            })
        },
        getWinningList(arr) {
            let mArr = [100, 100]
            if (arr && arr.length) {
                mArr = arr.map(x => x.amount)
            }
            const list = []
            for (let i = 0; i < 30; i++) {
                const start = this.randNum(1000, 9999)
                const end = this.randNum(100, 999)
                const mArrIdx = this.randNum(0, mArr.length - 1)
                const money = mArr[mArrIdx]
                const obj = {
                    phone: start + '****' + end,
                    money
                }
                list.push(obj)
            }
            this.winningList = list
        },
        randNum(m, n) {
            return Math.ceil(Math.random() * (n - m + 1) + m - 1)
        },
        onDataScroll() {
            if (this.dataScrollInterval) clearInterval(this.dataScrollInterval)
            this.dataScrollStyle = ''
            const dataScrollTimeout1 = setTimeout(() => {
                this.dataScrollStyle = 'transition: all 8s linear 0s;transform: translateY(-50%);'
                this.dataScrollInterval = setInterval(() => {
                    this.dataScrollStyle = ''
                    const dataScrollTimeout2 = setTimeout(() => {
                        this.dataScrollStyle =
                            'transition: all 8s linear 0s;transform: translateY(-50%);'
                        clearTimeout(dataScrollTimeout2)
                    }, 20)
                }, 8000)
                clearTimeout(dataScrollTimeout1)
            }, 20)
        },
        onTurn(id) {
            if (this.isTurnIng) return
            this.isTurnIng = true
            const params = {
                eventId: this.eventId,
                turntableSwitch: id,
                luckyWheelReward: this.luckyWheelReward
            }
            onTurntableDraw(params).then((res) => {
                const that = this
                if (res.code === 0) {
                    const D = res.result
                    let idx = 0
                    let imgUrl = ''
                    const list = that.turntableList[that.typeAct].luckyWheelModelDetailOddsVoList
                    list.forEach((x, i) => {
                        if (x.amount === D) {
                            idx = i
                            imgUrl = x.img || require('@/assets/turntable/icon-money.png')
                        }
                    })
                    if (D > 0) getUserInfo()
                    this.startLottery(idx).then(() => {
                        that.getTurntableInfo(that.eventId, true)
                        if (that.tabAct === 1) {
                            that.recordPageNo = 0
                            that.recordHasMore = true
                            that.recordLoading = false
                            that.recordList = []
                            that.getTurntableDrawRecords(true)
                        }
                        const winItem = {
                            title: that.$t('turntable.drawTitle1'),
                            message: `${that.$t('turntable.drawContent1')} ${that.CurrencyType} ${D}`,
                            imgUrl,
                            raspaAmt: D
                        }
                        this.$refs.WinPopup.open(winItem)
                        // Dialog.alert({
                        //     title: that.$t('turntable.drawTitle1'),
                        //     message: `${that.$t('turntable.drawContent1')} ${that.CurrencyType} ${D}`,
                        //     confirmButtonText: that.$t('lang.confirm'),
                        //     confirmButtonColor: 'var(--turntable2-popup-dialog-button-color)',
                        //     closeOnClickOverlay: true
                        // }).then(() => {
                        //     that.getTurntableInfo(that.eventId)
                        //     if (that.tabAct === 1) {
                        //         that.recordPageNo = 0
                        //         that.recordHasMore = true
                        //         that.recordLoading = false
                        //         that.recordList = []
                        //         that.getTurntableDrawRecords()
                        //     }
                        // })
                    })
                } else if (res.code === -1) {
                    this.isTurnIng = false
                }
            })
        },
        run(index) {
            return new Promise((resolve, reject) => {
                const duration = 5
                this.rotateTransition = `transform ${duration}s cubic-bezier(0.250, 0.460, 0.455, 0.995)`
                const list = this.turntableList.length ? this.turntableList[this.typeAct].luckyWheelModelDetailOddsVoList : []
                const length = list.length
                const rotateAngle = this.startRotateDegree + 10 * 360 + 360 - (180 / length + (360 / length) *
                    index) - (this.startRotateDegree % 360)
                this.startRotateDegree = rotateAngle
                this.rotateAngle = `rotate(${rotateAngle}deg)`
                setTimeout(() => {
                    resolve()
                    this.isTurnIng = false
                }, duration * 1000 + 1000)
            })
        },
        startLottery(idx) {
            return new Promise((resolve, reject) => {
                const aa = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
                let index = 0
                this.activeIndex = null
                this.speed = 50
                const updateInterval = () => {
                    this.intervalId = setInterval(() => {
                        this.activeIndex = aa[index % 10]
                        if (index >= 20 && aa[index % 10] === idx) {
                            clearInterval(this.intervalId)
                            resolve()
                            this.isTurnIng = false
                            return
                        }
                        index++
                        this.speed = this.speed + 20
                        clearInterval(this.intervalId)
                        updateInterval()
                    }, this.speed)
                }
                updateInterval()
            })
        }
    }
}
</script>

<style scoped lang="scss">
@import '@/common/styles/viriables.scss';

$turntable2-popup-dialog-button-color: $font-btn-color;
$turntable2-popup-total-decoration-bg: $bg-component-header-deep-color;
$turntable2-popup-total-text-soft: rgba($bg-component-input-focus-color, 0.8);
$turntable2-popup-total-text-strong: $bg-component-input-focus-color;
$turntable2-popup-total-bg: $bg-component-reward-chip-color;
$turntable2-popup-type-item-bg: $bg-component-button-disabled-color;
$turntable2-popup-type-item-active-bg: $bg-component-button-color;
$turntable2-popup-light-text-strong: rgba($font-color, 0.85);
$turntable2-popup-light-text-soft: rgba($font-color, 0.65);
$turntable2-popup-prize-text-color: rgba($bg-component-dark-color, 0.85);
$turntable2-popup-button-fill: linear-gradient($bg-component-input-focus-color, $bg-component-input-focus-color);
$turntable2-popup-button-border: linear-gradient(135deg, $font-component-info-accent-color, $font-component-info-bright-color);
$turntable2-popup-record-row-even-bg: $bg-component-neutral-color;
$turntable2-popup-record-money-color: $font-component-gold-base-color;

.popup {
    --turntable2-popup-dialog-button-color: #{$turntable2-popup-dialog-button-color};
    &.mobile {

        .van-popup {
            &.van-popup--center {
                width: 88.88% !important;
                height: max-content !important;
                max-width: 9rem !important;
                min-height: 98.8vh !important;
                max-height: 98.8vh !important;
                min-height: 98.8dvh !important;
                max-height: 98.8dvh !important;
            }

            .content {
                width: 100% !important;
                padding-bottom: .05rem;
                height: 100% !important;

                .header {
                    height: .94rem;
                    padding: 0 .28rem;

                    &>div:first-child {
                        font-size: .3rem;
                    }

                    .close {
                        font-size: .3rem;
                    }
                }

                .box {
                    padding: .03rem .28rem 0;

                    .total_box {
                        margin: 0 1rem;
                        position: relative;

                        .total_decoration {
                            position: absolute;
                            z-index: 1;
                            bottom: 0;
                            left: 50%;
                            transform: translateX(-50%);
                            width: 108%;
                            height: .18rem;
                            background: $turntable2-popup-total-decoration-bg;
                            border-radius: .51rem;
                        }
                    }

                    .total {
                        padding: .08rem;
                        margin: 0 0 .06rem;
                        border-radius: .16rem .16rem 0 0;

                        .total1 {
                            font-size: .2rem;
                            padding-bottom: 0;
                        }

                        .total2 {
                            font-size: .2rem;
                            padding-top: 0;
                            line-height: .22rem;
                        }
                    }

                    .turntable_content {
                        margin: -.28rem auto 0;

                        & > div.turntable_content_box{
                            height: 7.56rem;
                        }
                        .type {
                            column-gap: .1rem;
                            margin-bottom: .02rem;
                            padding-top: 0.46rem;

                            .item {
                                height: .7rem;
                                // border-radius: .08rem;

                                >div {
                                    &:first-child {
                                        font-size: .24rem;
                                    }

                                    &:last-child {
                                        font-size: .18rem;
                                    }
                                }
                            }
                        }

                        .turntable {
                            position: relative;
                            width: 4.11rem;
                            height: 5rem;
                            margin: 0 auto;
                            margin-top: .94rem;
                            z-index: 2;

                            .turntable_main {
                                display: grid;
                                grid-template-columns: repeat(3, 1fr);
                                gap: .1rem;
                                box-sizing: border-box;
                                z-index: 10;
                                position: relative;

                                .item {
                                    width: 1.3rem;
                                    height: 1.26rem;
                                    .chose_item {
                                        width: 1.4rem;
                                        height: 1.36rem;

                                        img {
                                            width: 100%;
                                            height: 100%;
                                        }
                                    }

                                    &:nth-child(n+4) {
                                        position: absolute;
                                    }

                                    &:nth-child(4) {
                                        right: 0;
                                        top: 1.34rem;
                                    }

                                    &:nth-child(5) {
                                        right: 0;
                                        top: 2.68rem;
                                    }

                                    &:nth-child(6) {
                                        right: 0;
                                        top: 4.02rem;
                                    }

                                    &:nth-child(7) {
                                        right: 1.402rem;
                                        top: 4.02rem;
                                    }

                                    &:nth-child(8) {
                                        left: 0;
                                        top: 4.02rem;
                                    }

                                    &:nth-child(9) {
                                        left: 0;
                                        top: 2.68rem;
                                    }

                                    &:nth-child(10) {
                                        left: 0;
                                        top: 1.34rem;
                                    }

                                    .item-content{
                                        .item-name{
                                            padding-top: .1rem;
                                        }
                                    }
                                    .item-empty{
                                        .item-img{
                                            width: .58rem;
                                            height: .58rem;
                                        }
                                    }
                                }
                            }
                            .turntable_btn {
                                top: 1.35rem;
                                padding: .24rem 0 .04rem;
                                width: 1.32rem;
                                height: 2.58rem;

                                .turntable_btn_img{
                                    width: 1rem;
                                    height: 1.08rem;
                                }
                            }
                        }
                    }
                    .action_btn {
                        width: 4.08rem;
                        height: .67rem;
                        bottom: 1.1rem;
                    }
                    .tabs {
                        margin: 0 0 .2rem;
                        border-radius: .24rem;

                        .tabs-header {
                            font-size: .26rem;
                            padding: 0 .28rem;

                            .tabs-header-item {
                                padding: 0 .2rem;

                                &.act {
                                    height: .7rem;
                                    line-height: .68rem;
                                }
                            }
                        }

                        .tabs-content {
                            border-radius: .24rem;
                            padding: .2rem .28rem;

                            .tabs-content-item {
                                height: 6.22rem;

                                &.records {

                                    .last-tips {
                                        line-height: .62rem;
                                        font-size: .28rem;
                                    }

                                    .empty {
                                        font-size: .28rem;

                                        .empty_img {
                                            width: 3.4rem;
                                            object-fit: contain;
                                        }
                                    }
                                }

                                .tr {
                                    height: .62rem;
                                    font-size: .22rem;
                                }
                            }
                        }
                    }

                    .rule_box {
                        border: .02rem solid $border-color;
                        font-size: .2rem;
                        padding: .2rem;

                        .title {
                            font-size: .24rem;
                            margin-bottom: .2rem;
                        }
                    }
                }
            }
        }
    }

    .van-popup {
        background: transparent;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        &.van-popup--center {
            max-height: 98.8vh !important;
            max-height: 98.8dvh !important;
        }

        .content {
            background: $bg-popup-color;
            width: 500px;
            border-radius: .24rem;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            padding-bottom: 10px;
            height: 100%;

            .header {
                display: flex;
                height: 76px;
                padding: 0 30px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                background: $bg-popup-navbar-color;

                &>div:first-child {
                    font-size: 20px;
                    font-weight: bold;
                    color: $font-color;
                }

                .close {
                    color: $font-component-muted-color;
                    font-size: 16px;
                    font-weight: bold;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    transition: all 0.3s;

                    &:hover {
                        color: $font-color;
                        rotate: -180deg;
                    }
                }
            }

            .box {
                flex: 1;
                display: flex;
                flex-direction: column;
                padding: 20px 30px 0;
                overflow-y: scroll;

                .total_box {
                    margin: 0 1.07rem;
                    position: relative;

                    .total_decoration {
                        position: absolute;
                        z-index: 1;
                        bottom: 0;
                        left: 50%;
                        transform: translateX(-50%);
                        width: 108%;
                        height: .18rem;
                        background: $turntable2-popup-total-decoration-bg;
                        border-radius: .51rem;
                    }
                }

                .total {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: column;
                    font-size: .24rem;
                    color: $turntable2-popup-total-text-soft;
                    line-height: .34rem;
                    text-align: center;
                    border-radius: .32rem .32rem 0 0;
                    background: $turntable2-popup-total-bg;
                    padding: .08rem .1rem;
                    position: relative;
                    z-index: 2;
                    // &::after{
                    // 	content: '';
                    // 	position: absolute;
                    // 	bottom: 0;
                    // 	width: 120%;
                    // 	height: 18upx;
                    // 	background: $bg-component-dark-color;
                    // 	border-radius: 51upx;
                    // }

                    .total1 {
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        // & > view:last-child{
                        // 	color: $font-component-gold-base-color;
                        // 	margin-left: 20upx;
                        // }
                        .num {
                            font-weight: bold;
                            color: $turntable2-popup-total-text-strong;
                            margin-left: .1rem;
                        }
                    }

                    .total2 {
                        margin-top: .06rem;
                        position: relative;
                        z-index: 1;

                        .num {
                            font-weight: bold;
                            color: $turntable2-popup-total-text-strong;
                            margin-left: .1rem;
                        }
                    }
                }

                .turntable_content {
                    width: 100%;
                    position: relative;
                    z-index: 0;
                    overflow: visible;
                    margin: -.28rem auto 0;
                    box-sizing: content-box;
                    background-image: url(@/assets/turntable/turntable_bg.png);
                    background-repeat: no-repeat;
                    background-size: 100% 100%;

                    & > div.turntable_content_box{
                        height: 10.1rem;
                    }
                    .type {
                        display: flex;
                        align-items: center;
                        justify-content: space-around;
                        margin: 0 .38rem;

                        padding-top: .58rem;
                        // &.type1 {
                        // 	background-image: url(@/static/imgs/turntable/bg_turntableType1.png);
                        // }

                        // &.type2 {
                        // 	background-image: url(@/static/imgs/turntable/bg_turntableType2.png);
                        // }

                        // &.type3 {
                        // 	background-image: url(@/static/imgs/turntable/bg_turntableType3.png);
                        // }

                        &>.item {
                            width: 2.16rem;
                            height: .94rem;
                            border-radius: .32rem .32rem 0 0;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            flex-direction: column;
                            background: $turntable2-popup-type-item-bg;
                            font-size: .18rem;
                            text-align: center;

                            &>view:first-child {
                                font-size: .28rem;
                                font-weight: bold;
                                margin-bottom: .04rem;
                                color: $turntable2-popup-light-text-strong;
                            }

                            &>view:last-child {
                                color: $turntable2-popup-light-text-soft;
                            }

                            &.act {
                                background: $turntable2-popup-type-item-active-bg;
                                border: 0;

                                &>view:first-child {
                                    color: $font-color;
                                }

                                &>view:last-child {
                                    color: $turntable2-popup-light-text-strong;
                                }
                            }
                        }
                    }

                    .turntable {
                        position: relative;
                        margin: 1.3rem 1.12rem .2rem;
                        z-index: 2;
                    }
                    .turntable_main {
                        display: grid;
                        grid-template-columns: repeat(3, 1fr);
                        gap: .15rem;
                        z-index: 1;
                        box-sizing: border-box;
                        z-index: 10;
                        position: relative;

                        .item {
                            width: 1.62rem;
                            height: 1.62rem;
                            background: url(@/assets/turntable/item_bg.png) no-repeat;
                            background-size: 100% 100%;
                            position: relative;

                            // &.active {
                            // 	background: url(@/static/imgs/turntable/item_act_bg.png) no-repeat;
                            // 	background-size: 100% 100%;
                            // }
                            .chose_item {
                                position: absolute;
                                top: 50%;
                                left: 50%;
                                transform: translate(-50%, -50%);
                                width: 1.82rem;
                                height: 1.76rem;

                                img {
                                    width: 100%;
                                    height: 100%;
                                }
                            }

                            &:nth-child(n+4) {
                                position: absolute;
                            }

                            &:nth-child(4) {
                                right: 0;
                                top: 1.8rem;
                            }

                            &:nth-child(5) {
                                right: 0;
                                top: 3.6rem;
                            }

                            &:nth-child(6) {
                                right: 0;
                                top: 5.4rem;
                            }

                            &:nth-child(7) {
                                right: 1.78rem;
                                top: 5.4rem;
                            }

                            &:nth-child(8) {
                                left: 0;
                                top: 5.4rem;
                            }

                            &:nth-child(9) {
                                left: 0;
                                top: 3.6rem;
                            }

                            &:nth-child(10) {
                                left: 0;
                                top: 1.8rem;
                            }

                            .item-content {
                                box-sizing: border-box;
                                width: 100%;
                                height: 100%;
                                display: flex;
                                flex-direction: column;
                                justify-content: center;
                                align-items: center;

                                .item-name {
                                    padding-top: .2rem;
                                    font-size: .24rem;
                                    color: $turntable2-popup-prize-text-color;
                                }

                                .item-img {
                                    width: .58rem;
                                    height: .58rem;
                                    margin-top: .2rem;
                                    // vertical-align: middle;
                                }
                            }

                            .item-empty {
                                position: absolute;
                                // padding-top: .78rem;
                                box-sizing: border-box;
                                width: 100%;
                                height: 100%;
                                left: -50%;
                                top: -50%;
                                transform: translate(50%, 50%);
                                display: flex;
                                flex-direction: column;
                                justify-content: center;
                                align-items: center;

                                .item-img {
                                    width: .88rem;
                                    height: .88rem;
                                    vertical-align: middle;
                                }
                            }
                        }
                    }
                    .turntable_btn {
                        color: $font-color;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        align-items: center;
                        padding: .24rem 0 .04rem;
                        position: absolute;
                        width: 1.66rem;
                        height: 3.38rem;
                        top: 1.8rem;
                        left: 50%;
                        transform: translateX(-50%);
                        z-index: 11;
                        text-align: center;
                        border: .06rem solid transparent;
                        background-clip: padding-box, border-box;
                        background-origin: padding-box, border-box;
                        background-image: $turntable2-popup-button-fill, $turntable2-popup-button-border;
                        border-radius: .13rem;

                        .nums {
                            font-size: .4rem;
                            line-height: .4rem;
                            margin-bottom: .08rem;
                        }

                        .draw_txt {
                            font-size: .24rem;
                            line-height: .24rem;
                        }

                        .turntable_btn_img {
                            width: 1.36rem;
                            height: 1.49rem;
                        }
                    }
                }
                .action_btn {
                    position: absolute;
                    z-index: 2;
                    bottom: 1.4rem;
                    left: 50.1%;
                    transform: translateX(-50%);
                    width: 4.98rem;
                    height: 1rem;

                    img {
                        width: 100%;
                        height: 100%;
                    }
                }

                .tabs {
                    margin: 15px 0;
                    background: $bg-shell-color;
                    border-radius: .24rem;

                    .tabs-header {
                        box-sizing: border-box;
                        font-size: 14px;
                        color: $turntable2-popup-light-text-soft;
                        margin: 0 auto;
                        position: relative;
                        z-index: 2;
                        display: flex;
                        align-items: center;
                        padding: 0 14px;

                        .tabs-header-item {
                            cursor: pointer;
                            padding: 0 10px;
                            border-radius: .24rem;
                            text-align: center;
                            flex: 1;

                            &.act {
                                height: 45px;
                                line-height: 44px;
                                color: $font-color;
                                font-weight: bold;
                                position: relative;
                                color: $font-component-hot-soft-color;

                                &:after {
                                    content: '';
                                    width: 0;
                                    height: 0;
                                    border-left: .1rem solid transparent;
                                    border-right: .1rem solid transparent;
                                    border-bottom: .1rem solid $font-component-hot-soft-color;
                                    position: absolute;
                                    bottom: .12rem;
                                    left: 50%;
                                    transform: translate(-50%, 100%);
                                }
                            }
                        }
                    }

                    .tabs-content {
                        border-radius: .24rem;
                        padding: 20px 14px;
                        padding-top: 0;

                        .tabs-content-inset {
                            border-radius: .24rem;
                        }

                        .tabs-content-item {
                            height: 311px;
                            overflow: hidden;
                            border-radius: .24rem;

                            &.records {
                                overflow: auto;
                                position: relative;

                                .last-tips {
                                    line-height: 31px;
                                    width: 100%;
                                    text-align: center;
                                    color: $font-sub-color;
                                    font-size: 14px;
                                }

                                .empty {
                                    position: absolute;
                                    left: 50%;
                                    top: 50%;
                                    transform: translate(-50%, -50%);
                                    color: $font-sub-color;
                                    font-size: 16px;
                                    text-align: center;

                                    .empty_img {
                                        width: 170px;
                                        object-fit: contain;
                                    }
                                }
                            }

                            .tr {
                                height: 31px;
                                display: flex;
                                align-items: center;
                                justify-content: space-between;
                                color: $font-color;
                                font-size: 11px;

                                &:nth-child(2n+1) {
                                    background: $bg-component-neutral-color;
                                }

                                &:nth-child(2n) {
                                    // background: $turntable2-popup-record-row-even-bg;
                                }

                                .td {
                                    text-align: center;
                                    width: 36%;
                                    white-space: nowrap;

                                    &:last-child {
                                        width: 28%;
                                    }

                                    &.money {
                                        color: $turntable2-popup-record-money-color;
                                    }
                                }
                            }
                        }
                    }
                }

                .rule_box {
                    border: 2px solid $border-color;
                    color: $font-sub-color;
                    font-size: 12px;
                    text-align: left;
                    border-radius: .24rem;
                    padding: 10px;

                    .title {
                        font-size: 16px;
                        margin-bottom: 10px;
                        font-weight: bold;
                    }
                }
            }
        }
    }
}
</style>
